import { render, staticRenderFns } from "./PaymentKasbonCombination.vue?vue&type=template&id=3a45287e"
import script from "./PaymentKasbonCombination.vue?vue&type=script&lang=js"
export * from "./PaymentKasbonCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports